@if (options()) {
  @if (options().label) {
    <label
      [id]="options().label?.id"
      [for]="!invalidMessage && options().id"
      [class]="'form-label ' + (options().label?.class || '')"
    >
      {{ translations.labels[options().label?.text || 'label'] || options().label?.text }}
      @if (options().required) {
        <span class="required">*</span>
      }
    </label>
  }
  @if (options().formGroup && options().formControlName && !options().formControl) {
    <span [formGroup]="options().formGroup!">
      <div class="input-group">
        <input
          #el="ngbDatepicker"
          ngbDatepicker
          [id]="options().id"
          [attr.name]="options().name"
          [type]="InputTypes.text"
          [attr.inputmode]="InputModes.text"
          [class]="'form-control ncp-input ' + (options().inputClass || '')"
          [placeholder]="translations.placeholders[options().placeholder || 'default']"
          [formControlName]="options().formControlName!"
          (keydown)="onKeyDown($event, value)"
          (keyup)="onKeyUp($event, value)"
          (input)="onInput($any($event).target)"
          (blur)="onBlur(value)"
          [value]="options().value"
          [minDate]="minDate!"
          [maxDate]="maxDate!"
        />
        <ncp-button
          [options]="{
            class: 'iconButtonMedium',
            icon: 'bi bi-calendar3',
            type: ButtonTypes.button,
            disabled: options().disabled
          }"
          (click)="(!options().disabled) ? el.toggle() : null"
        />
      </div>
    </span>
  } @else if (!options().formGroup && !options().formControlName && options().formControl) {
    <div class="input-group">
      <input
        #el="ngbDatepicker"
        ngbDatepicker
        [id]="options().id"
        [attr.name]="options().name"
        [type]="InputTypes.text"
        [attr.inputmode]="InputModes.text"
        [class]="'form-control ncp-input ' + (options().inputClass || '')"
        [placeholder]="translations.placeholders[options().placeholder || 'default']"
        [formControl]="options().formControl!"
        (keydown)="onKeyDown($event, value)"
        (keyup)="onKeyUp($event, value)"
        (input)="onInput($any($event).target)"
        (blur)="onBlur(value)"
        [value]="options().value"
        [minDate]="minDate!"
        [maxDate]="maxDate!"
      />
      <ncp-button
        [options]="{
          class: 'iconButtonMedium',
          icon: 'bi bi-calendar3',
          type: ButtonTypes.button,
          disabled: options().formControl?.disabled
        }"
        (click)="(options().formControl?.enabled) ? el.toggle() : null"
      />
    </div>
  } @else if (!options().formGroup && !options().formControlName && !options().formControl) {
    <div class="input-group">
      <input
        #el="ngbDatepicker"
        ngbDatepicker
        [(ngModel)]="value"
        [id]="options().id"
        [attr.name]="options().name"
        [type]="InputTypes.text"
        [attr.inputmode]="InputModes.text"
        [class]="'form-control ncp-input ' + (options().inputClass || '')"
        [placeholder]="translations.placeholders[options().placeholder || 'default']"
        (keydown)="onKeyDown($event, value)"
        (keyup)="onKeyUp($event, value)"
        (input)="onInput($any($event).target)"
        (blur)="onBlur(value)"
        [value]="options().value"
        [minDate]="minDate!"
        [maxDate]="maxDate!"
      />
      <ncp-button
        [options]="{
          class: 'iconButtonMedium',
          icon: 'bi bi-calendar3',
          type: ButtonTypes.button,
          disabled: options().disabled
        }"
        (click)="(!options().disabled) ? el.toggle() : null"
      />
    </div>
  } @else if (options().formGroup && options().formControlName && options().formControl) {
    <div
      class="alert alert-danger"
      role="alert"
    >
      <span class="badge rounded-pill bg-secondary">Developer</span>: Cannot set FormControl and the
      combination FormGroup - FormControlName at the same time
    </div>
  } @else if (options().formGroup && !options().formControlName && options().formControl) {
    <div
      class="alert alert-danger"
      role="alert"
    >
      <span class="badge rounded-pill bg-secondary">Developer</span>: Cannot set FormControl and
      FormGroup at the same time
    </div>
  } @else if (!options().formGroup && options().formControlName && options().formControl) {
    <div
      class="alert alert-danger"
      role="alert"
    >
      <span class="badge rounded-pill bg-secondary">Developer</span>: Cannot set FormControl and
      FormControlName at the same time
    </div>
  } @else if (options().formGroup && !options().formControlName && !options().formControl) {
    <div
      class="alert alert-danger"
      role="alert"
    >
      <span class="badge rounded-pill bg-secondary">Developer</span>: Cannot set FormGroup without
      setting FormControlName too
    </div>
  } @else if (!options().formGroup && options().formControlName && !options().formControl) {
    <div
      class="alert alert-danger"
      role="alert"
    >
      <span class="badge rounded-pill bg-secondary">Developer</span>: Cannot set FormControlName
      without setting FormGroup too
    </div>
  }
  <div class="invalid-feedback">
    {{ invalidMessage }}
  </div>
} @else {
  <div
    class="alert alert-danger"
    role="alert"
  >
    <span class="badge rounded-pill bg-secondary">Developer</span>: Cannot instantiate input without
    options() set
  </div>
}
